import { createFetchGqlClient } from 'utils';
import { getFrontierApiUrl } from '../utils/url';
import { apiConvert } from './endpoints';

export const fetchGql = createFetchGqlClient({
  url: getFrontierApiUrl(apiConvert),
});
